import { render, staticRenderFns } from "./global-user-relation.vue?vue&type=template&id=0bcf9daf&scoped=true&"
import script from "./global-user-relation.vue?vue&type=script&lang=js&"
export * from "./global-user-relation.vue?vue&type=script&lang=js&"
import style0 from "./global-user-relation.vue?vue&type=style&index=0&id=0bcf9daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf9daf",
  null
  
)

export default component.exports